import {ELEMENT} from '../incase-domain/elements/base/ElementTypes';

interface QuestionReportLinkElement {
    id?: string;
    type?: string;
    htmlSlotId?: string;
    questionHtmlSlotId?: string;
    questionSlideName?: string;
    questionElementId?: string;
}

interface QuestionReportSlideLink {
    name?: string;
    elements?: QuestionReportLinkElement[];
}

const QUESTION_SLOT_TYPES = new Set<string>([ELEMENT.QUESTION, ELEMENT.MULTI_SELECT]);

function missingQuestionReportMessage(reportSlotId: string, questionSlotId: string, slideName?: string): string {
    const where = slideName ? ` on slide "${slideName}"` : ' on this slide';
    return `Question report "${reportSlotId}" has no question slot "${questionSlotId}"${where}`;
}

export function linkQuestionReportSlots(slides: QuestionReportSlideLink[], strict: boolean, onlySlideName?: string): void {
    slides.forEach((slide) => {
        if (onlySlideName && slide.name !== onlySlideName) return;

        const elements = slide.elements ?? [];
        elements.forEach((element, index) => {
            if (element.type !== ELEMENT.QUESTION_REPORT || !element.questionHtmlSlotId) return;

            const targetName = element.questionSlideName || slide.name;
            const question = slides
                .find((item) => item.name === targetName)
                ?.elements?.find(
                    (candidate) => candidate.htmlSlotId === element.questionHtmlSlotId && QUESTION_SLOT_TYPES.has(candidate.type ?? '')
                );

            if (!question) {
                if (strict) {
                    throw new Error(
                        missingQuestionReportMessage(element.htmlSlotId ?? '', element.questionHtmlSlotId, element.questionSlideName)
                    );
                }
                return;
            }

            if (!question.id || element.questionElementId === question.id) return;
            elements[index] = {...element, questionElementId: question.id};
        });
    });
}
